export enum EntityType {
    GROUP = "GROUP",
    STORE = "STORE"
}
